import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { TransitionPhase, Zone } from "@/models/types";
import { useI18n } from "@/i18n/I18nContext";

interface TransitionCueProps {
  phase: TransitionPhase;
  secondsUntil: number;
  nextZone: Zone | null;
  intensity: number;
}

export const TransitionCue: React.FC<TransitionCueProps> = ({
  phase,
  secondsUntil,
  nextZone,
  intensity,
}) => {
  const { tm } = useI18n();
  const show = phase !== "NORMAL" && nextZone && isFinite(secondsUntil);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="transition-cue"
          initial={{ opacity: 0, x: 10 }}
          animate={{ opacity: 0.55 + intensity * 0.45, x: 0 }}
          exit={{ opacity: 0, x: 10 }}
          transition={{ duration: 0.4 }}
          className="flex items-center gap-2 rounded-full px-3 py-1.5"
          style={{
            background: phase === "MOVE" ? "rgba(245,158,11,0.18)" : "rgba(217,119,6,0.1)",
            border: "1px solid rgba(245,158,11,0.35)",
          }}
        >
          <motion.span
            className="block rounded-full bg-amber-400"
            animate={{ scale: [1, 1.4, 1], opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 0.9, repeat: Infinity, ease: "easeInOut" }}
            style={{ width: 7, height: 7 }}
          />
          <span className="font-mono text-[11px] tracking-widest uppercase text-amber-200">
            {phase === "MOVE" ? `${tm("messages", "MOVE")} →` : `${nextZone?.label} · ${Math.max(0, Math.ceil(secondsUntil))}s`}
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
